/**
 * 施工申請單_承攬商填寫表單關聯配置
 * 表單ID: b05f45f4-8083-460e-9f18-f89bf23883ad
 */

import { FormRelationshipConfig } from '../relationship-types';

export const ContractorConstructionFormConfig: FormRelationshipConfig = {
  formId: 'b05f45f4-8083-460e-9f18-f89bf23883ad',
  formName: '施工申請單_承攬商填寫',
  description: '承攬商施工申請單的欄位關聯配置',
  relationships: [
    {
      id: 'date_range_initial_setup',
      description: '作業起訖日：初始化時設定開始日期約束為今天+7天',
      when: {
        field: 'date_range_1',              // 直接監聽日期範圍欄位本身
        isEmpty: true                       // 當欄位為空時觸發（初始狀態）
      },
      then: [
        {
          field: 'date_range_1',
          action: 'setMinStartDate',        // 設定最小開始日期（日期範圍元件專用）
          value: 'today+7days',             // 今天 + 7 天
          delay: 100
        },
        {
          field: 'date_range_1',
          action: 'setStartDate',           // 自動設定開始日期
          value: 'today+7days',             // 今天 + 7 天
          delay: 150
        }
      ]
    },

    {
      id: 'special_operations_hanging_constraint',
      description: '特殊作業：當包含「吊掛」時，開始日期最小值為今天+21天',
      when: {
        field: 'referencedata_special-operations',  // 監聽攤平後的特殊作業欄位
        custom: (value: any) => {
          console.log('[FieldRelationship] 檢查 referencedata_special-operations 是否包含吊掛:', value);
          
          // 處理攤平後的資料格式，value 可能是 { type: 'multi-checkbox', value: [...] }
          let specialOps = value;
          if (value && typeof value === 'object' && value.value !== undefined) {
            specialOps = value.value;
          }
          
          console.log('[FieldRelationship] special-operations 值:', specialOps);
          
          if (Array.isArray(specialOps)) {
            const hasHanging = specialOps.includes('吊掛');
            console.log('[FieldRelationship] 是否包含吊掛:', hasHanging);
            return hasHanging;
          }
          return false;
        }
      },
      then: [
        {
          field: 'date_range_1',
          action: 'setMinStartDate',        // 設定最小開始日期
          value: 'today+21days',            // 今天 + 21 天（吊掛作業需更長準備時間）
          delay: 100
        },
        {
          field: 'date_range_1',
          action: 'setStartDate',           // 自動設定開始日期
          value: 'today+21days',            // 今天 + 21 天
          delay: 150
        }
      ]
    },

    {
      id: 'emergency_work_type_constraint',
      description: '作業類型：當為「緊急搶修」時，開始日期可以從今天開始',
      when: {
        field: 'referencedata_work-type',  // 監聽攤平後的作業類型欄位
        custom: (value: any) => {
          console.log('[FieldRelationship] 檢查 referencedata_work-type 是否為緊急搶修:', value);
          
          // 處理攤平後的資料格式，value 可能是 { type: 'pre-filled', key: 'xxx', value: 'xxx' }
          let workTypeValue = '';
          if (value && typeof value === 'object') {
            if (value.value !== undefined) {
              workTypeValue = value.value;
            } else if (value.key !== undefined) {
              workTypeValue = value.key;
            }
          } else if (typeof value === 'string') {
            workTypeValue = value;
          }
          
          console.log('[FieldRelationship] work-type 值:', workTypeValue);
          
          const isEmergencyWork = workTypeValue === '緊急搶修';
          console.log('[FieldRelationship] 是否為緊急搶修:', isEmergencyWork);
          return isEmergencyWork;
        }
      },
      then: [
        {
          field: 'date_range_1',
          action: 'setMinStartDate',        // 設定最小開始日期
          value: 'today',                   // 今天（緊急搶修可以當天開始）
          delay: 100
        },
        {
          field: 'date_range_1',
          action: 'setStartDate',           // 自動設定開始日期
          value: 'today',                   // 今天
          delay: 150
        }
      ]
    },

    {
      id: 'date_range_end_validation',
      description: '確保結束日期不能早於開始日期',
      when: {
        field: 'date_range_1',              // 監聽日期範圍欄位
        action: 'startDateChanged'          // 當開始日期改變時
      },
      then: [
        {
          field: 'date_range_1',
          action: 'setMinEndDate',          // 設定最小結束日期
          value: 'startDate',               // 不能早於開始日期
          delay: 100
        }
      ]
    }
  ]
};